import {
  addListenetOnOutLinedInput,
  changeInputFileHandler,
} from "../general/ui";
import SlimSelect from "slim-select";
import { Notyf } from "notyf";
import AirDatepicker from "air-datepicker";

document.addEventListener("DOMContentLoaded", () => {
  const notyf = new Notyf({
    position: {
      x: "right",
      y: "top",
    },
    duration: 10000,
    dismissible: true,
  });
  //create select
  let selectArray = [];
  const createSelect = () => {
    const selectLectorsEl = document.querySelectorAll(
      "select._js-lectors-update"
    );

    for (let index = 0; index < selectLectorsEl.length; index++) {
      const element = selectLectorsEl[index];
      const item = new SlimSelect({
        select: element,
        showSearch: false,
        showContent: "down",
        allowDeselectOption: true,
      });
      element.style.cssText = "";
      element.classList.add("_hide-select");
      selectArray.push(item);
    }
  };
  window.$.validator.prototype.checkForm = function () {
    this.prepareForm();
    for (
      var i = 0, elements = (this.currentElements = this.elements());
      elements[i];
      i++
    ) {
      if (
        this.findByName(elements[i].name).length != undefined &&
        this.findByName(elements[i].name).length > 1
      ) {
        for (
          var cnt = 0;
          cnt < this.findByName(elements[i].name).length;
          cnt++
        ) {
          this.check(this.findByName(elements[i].name)[cnt]);
        }
      } else {
        this.check(elements[i]);
      }
    }
    return this.valid();
  };
  //validation
  var validationForm = $("#course-edit-form").validate({
    submitHandler: function (form) {
      form.submit();
    },
    errorElement: "span",
    errorClass: "_error",

    errorPlacement: function (error, element) {
      if (element.attr("type") === "checkbox") {
        error.appendTo(
          element.parent(".checkbox__body").siblings(".checkbox__helper")
        );
      }
      if (element[0].tagName === "SELECT") {
        error.appendTo(element.siblings(".select__error"));
      }
      error.appendTo(
        element
          .parent(".outline-field__body")
          .siblings(".outline-field__helper")
      );
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parent(".outline-field__body").addClass(errorClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parent(".outline-field__body").removeClass(errorClass);
    },

    rules: {
      course_name: {
        required: true,
        minlength: 2,
      },
      course_descr: {
        required: true,
        minlength: 5,
      },
      course_date: {
        required: true,
      },
      course_mode: {
        required: true,
      },
      course_duration: {
        required: true,
      },
      course_type: {
        required: true,
      },
      course_doc: {
        required: true,
      },
      course_education: {
        required: true,
      },
      course_lect_name: {
        required: true,
      },
      course_lect_descr: {
        required: true,
      },
      course_price: {
        required: true,
      },
      course_lector_choose: {
        required: true,
      },
    },
    messages: {
      course_name: {
        required: "Поле обязательно для заполнения",
        minlength: "Длина имени должна быть более 2-х симовлов",
      },
      course_descr: {
        required: "Поле обязательно для заполнения",
        minlength: "Длина имени должна быть более 5 симовлов",
      },
      course_date: {
        required: "Поле обязательно для заполнения",
      },
      course_mode: {
        required: "Поле обязательно для заполнения",
      },
      course_duration: {
        required: "Поле обязательно для заполнения",
      },
      course_type: {
        required: "Поле обязательно для заполнения",
      },
      course_doc: {
        required: "Поле обязательно для заполнения",
      },
      course_education: {
        required: "Поле обязательно для заполнения",
      },
      course_lect_name: {
        required: "Поле обязательно для заполнения",
      },
      course_lect_descr: {
        required: "Поле обязательно для заполнения",
      },
      course_price: {
        required: "Поле обязательно для заполнения",
      },
      course_lector_choose: {
        required: "Поле обязательно для заполнения",
      },
    },
  });
  //validation lector edit
  var validationFormLector = $("#add_lector_form").validate({
    submitHandler: function (form, e) {
      e.preventDefault();
      // console.log(form.getAttribute('action'));
      const formData = new FormData(form);
      const url = form.getAttribute("action");

      window.$.ajax({
        url: url,
        type: "POST",
        data: formData,
        processData: false,
        beforeSend: function () {
          window
            .$(form)
            .find(".edit-modal__loader")
            .append('<div class="loader"></div>');
        },
      })
        .done(function (data) {
          const {
            result: { success, error },
          } = JSON.parse(data);
          if (error && error !== "") {
            notyf.error(error);
          } else {
            notyf.success("Новый лектор создан");
            //clear form
            window.$(form).trigger("reset");
            const fileInput = $(form).find(".input-file__input")[0];
            let event = new Event("input");
            fileInput.dispatchEvent(event);
            //update select data
            const selects = document.querySelectorAll(
              "select._js-lectors-update"
            );
            Array.prototype.forEach.call(selects, (item) => {
              item.insertAdjacentHTML(
                "beforeend",
                `<option value="${success.id}">${success.name}</option>`
              );
            });
          }
        })
        .fail(function () {
          notyf.error("Что-то пошло не так");
        })
        .always(function () {
          window.$(form).find(".loader").remove();
        });
    },
    errorElement: "span",
    errorClass: "_error",

    errorPlacement: function (error, element) {
      error.appendTo(
        element
          .parent(".outline-field__body")
          .siblings(".outline-field__helper")
      );
    },
    highlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").addClass(errorClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").removeClass(errorClass);
    },

    rules: {
      teacher_name: {
        required: true,
      },
      teacher_pos: {
        required: true,
      },
      teacher_descr: {
        required: true,
      },
    },
    messages: {
      teacher_name: {
        required: "Поле обязательно для заполнения",
      },
      teacher_pos: {
        required: "Поле обязательно для заполнения",
      },
      teacher_descr: {
        required: "Поле обязательно для заполнения",
      },
    },
  });

  //repeater
  const btnAddGroup = document.querySelectorAll("._repeat-btn");
  const groupRepeteableBox = document.querySelectorAll(".c-edit__repeat");

  const repeatBoxObj = {};
  for (let index = 0; index < groupRepeteableBox.length; index++) {
    const element = groupRepeteableBox[index];
    repeatBoxObj[element.getAttribute("data-repeat")] = {
      el: element,
      repeat: element.querySelector(".c-edit__repeat-box").cloneNode(true),
    };
  }
  createSelect();
  const createDeleteBtn = (lastAddedElement, parentNode) => {
    const btnDeleteElement = document.createElement("button");
    btnDeleteElement.classList.add(
      "c-edit__delete",
      "btn",
      "btn_outlined",
      "btn--secondary"
    );
    btnDeleteElement.textContent = "Удалить";
    lastAddedElement.appendChild(btnDeleteElement);
    btnDeleteElement.addEventListener("click", (e) => {
      e.preventDefault();
      parentNode.removeChild(lastAddedElement);
      const allBoxes = parentNode.querySelectorAll(".c-edit__repeat-box");
      Array.prototype.forEach.call(allBoxes, (item, index) => {
        const boxSubtitle = item.querySelector(".c-edit__subtitle");
        if (boxSubtitle) boxSubtitle.setAttribute("data-count", index + 1);
      });
    });
  };
  // console.log(repeatBoxObj);
  for (let index = 0; index < btnAddGroup.length; index++) {
    const btnAddGroupEl = btnAddGroup[index];
    btnAddGroupEl.addEventListener("click", (e) => {
      e.preventDefault();
      const dataAttr = btnAddGroupEl.getAttribute("data-repeat");

      selectArray.forEach((item) => {
        item.destroy();
      });
      selectArray = [];
      repeatBoxObj[dataAttr].el.appendChild(
        repeatBoxObj[dataAttr].repeat.cloneNode(true)
      );
      const allBoxes = repeatBoxObj[dataAttr].el.querySelectorAll(
        ".c-edit__repeat-box"
      );
      const lastAddedElement = allBoxes[allBoxes.length - 1];
      createDeleteBtn(lastAddedElement, repeatBoxObj[dataAttr].el);
      // console.log(lastAddedElement);
      if (lastAddedElement.querySelector(".c-edit__subtitle") !== null) {
        lastAddedElement
          .querySelector(".c-edit__subtitle")
          .setAttribute("data-count", allBoxes.length);
      }
      const textFields = lastAddedElement.querySelectorAll(".outline-field");
      const fileField = lastAddedElement.querySelector(".input-file");
      for (let index = 0; index < textFields.length; index++) {
        const element = textFields[index];
        const input = element.querySelector(".outline-field__input");
        const label = element.querySelector(".outline-field__label");
        const inputId = `${input.getAttribute("id").slice(0, -1)}${
          allBoxes.length
        }`;
        input.setAttribute("id", inputId);
        label.setAttribute("for", inputId);
      }

      addListenetOnOutLinedInput(lastAddedElement.querySelectorAll("._input"));
      if (fileField !== null) {
        fileField
          .querySelector(".input-file__input")
          .addEventListener("change", (e) => {
            changeInputFileHandler(fileField, e.target);
          });
      }
      createSelect();
    });
  }
  //stats date choose
  const statsCardsEl = document.querySelectorAll(".pf-stats__card");

  if (statsCardsEl) {
    Array.prototype.forEach.call(statsCardsEl, (item) => {
      const inputFrom = item.querySelector("._js-date-from");
      const inputTo = item.querySelector("._js-date-to");
      const inputFromTrigger = item.querySelector("._js-date-trigger-from");
      const inputToTrigger = item.querySelector("._js-date-trigger-to");

      const dateFrom = new AirDatepicker(inputFrom, {
        onSelect({ date }) {
          dateTo.update({
            minDate: date,
          });
        },
      });
      inputFromTrigger.addEventListener("click", (e) => {
        e.stopPropagation();
        dateFrom.show();
      });

      const dateTo = new AirDatepicker(inputTo, {
        onSelect({ date }) {
          dateFrom.update({
            maxDate: date,
          });
        },
      });
      inputToTrigger.addEventListener("click", (e) => {
        e.stopPropagation();
        dateTo.show();
      });

      document.addEventListener("click", (e) => {
        console.log(e);

        if (
          !inputFromTrigger.isEqualNode(e.srcElement) &&
          !document
            .getElementById("air-datepicker-global-container")
            .contains(e.target)
        ) {
          dateFrom.hide();
        }
        if (
          !inputToTrigger.isEqualNode(e.srcElement) &&
          !document
            .getElementById("air-datepicker-global-container")
            .contains(e.target)
        ) {
          dateTo.hide();
        }
      });
    });
  }
});
